
const navigation = {
  home: '首页',
  sugar: '糖',
  coffee: '咖啡',
  logistics: '物流',
  news: '新闻',
  contact: '联系'
};

const hero = {
  title: '大宗商品出口',
  subtitle: '巴西糖和咖啡销往世界',
  description: '巴西是糖和咖啡生产和出口的全球领导者。本网站全面介绍这些产品、市场、出口物流等内容。',
  exploreSugar: '探索糖',
  discoverCoffee: '发现咖啡'
};

const features = {
  title: '探索我们的栏目',
  description: '详细了解巴西主要大宗商品的工艺、市场和物流信息',
  sugar: {
    title: '了解糖出口流程',
    description: '从田间到港口：了解巴西糖如何进入国际市场'
  },
  coffee: {
    title: '发现巴西咖啡之路',
    description: '使巴西成为世界最大咖啡出口国的传统和品质'
  },
  logistics: {
    title: '了解物流和货船',
    description: '实现出口的港口和运输基础设施'
  },
  learnMore: '了解更多'
};

const stats = {
  title: '巴西数据',
  description: '展示巴西在全球大宗商品市场重要性的数据',
  sugarExport: '生产的糖用于出口',
  coffeeWorld: '世界咖啡来自巴西',
  mainPorts: '主要出口港口',
  countries: '目的地国家'
};

const cta = {
  title: '保持更新',
  description: '关注大宗商品市场的最新趋势和行业新闻',
  seeNews: '查看新闻',
  contact: '联系我们'
};

// Sugar page translations
const sugar = {
  hero: {
    title: '巴西糖',
    subtitle: '从田间到港口'
  },
  types: {
    title: '出口糖类型',
    vhp: {
      name: 'VHP（极高偏振糖）',
      description: '高偏振原糖，适合精炼'
    },
    refined: {
      name: '精制糖',
      description: '白色精制糖，可直接食用'
    },
    crystal: {
      name: '结晶糖',
      description: '结晶糖，在国内市场更常见'
    }
  },
  regions: {
    title: '主要产区',
    sp: {
      name: '圣保罗州',
      production: '55%',
      description: '全国最大产区'
    },
    mg: {
      name: '米纳斯吉拉斯州',
      production: '12%',
      description: '第二大产区'
    },
    go: {
      name: '戈亚斯州',
      production: '10%',
      description: '中西部重要产区'
    }
  },
  process: {
    title: '出口流程',
    step1: {
      title: '甘蔗收获',
      description: '机械化或人工甘蔗收获'
    },
    step2: {
      title: '糖厂加工',
      description: '碾磨和提取甘蔗汁'
    },
    step3: {
      title: '储存和运输',
      description: '储存在筒仓中并公路运输'
    },
    step4: {
      title: '港口装船',
      description: '装载到散货船'
    }
  },
  market: {
    title: '国际市场',
    destinations: '主要目的地',
    factors: {
      title: '影响价格的因素',
      climate: {
        title: '气候条件：',
        description: '干旱或过度降雨影响生产'
      },
      oil: {
        title: '石油价格：',
        description: '影响乙醇作为替代品的生产'
      },
      demand: {
        title: '全球需求：',
        description: '人口增长和消费变化'
      },
      exchange: {
        title: '汇率：',
        description: '美元变化影响竞争力'
      }
    }
  },
  curiosities: {
    title: '巴西糖趣事',
    exported: '巴西产糖用于出口',
    worldShare: '世界糖来自巴西',
    mills: '全国运营的糖厂',
    hectares: '甘蔗种植公顷数',
    worldRank: '世界产量排名',
    countries: '国家进口我们的糖'
  }
};

// Coffee page translations
const coffee = {
  hero: {
    title: '巴西咖啡',
    subtitle: '传统与世界品质'
  },
  history: {
    title: '历史与经济重要性',
    worldProduction: '世界产量',
    jobs: '创造就业',
    exports: '年出口额',
    importers: '进口国'
  },
  types: {
    title: '出口咖啡类型',
    arabica: {
      name: '阿拉比卡',
      percentage: '75%',
      description: '高品质咖啡，口感温和芳香',
      regions: '米纳斯吉拉斯、圣保罗、圣埃斯皮里图'
    },
    robusta: {
      name: '罗布斯塔（康尼隆）',
      percentage: '25%',
      description: '抗性更强的咖啡，口感浓烈，咖啡因含量更高',
      regions: '圣埃斯皮里图、朗多尼亚、巴伊亚'
    }
  },
  states: {
    title: '产区州',
    mg: {
      name: '米纳斯吉拉斯',
      production: '54%',
      specialty: '山地阿拉比卡'
    },
    es: {
      name: '圣埃斯皮里图',
      production: '23%',
      specialty: '康尼隆和阿拉比卡'
    },
    sp: {
      name: '圣保罗',
      production: '9%',
      specialty: '传统阿拉比卡'
    },
    ba: {
      name: '巴伊亚',
      production: '8%',
      specialty: '康尼隆和特种咖啡'
    }
  },
  process: {
    title: '出口流程',
    step1: {
      title: '收获',
      description: '手工（采摘）或机械'
    },
    step2: {
      title: '干燥',
      description: '天然晾晒或人工干燥'
    },
    step3: {
      title: '加工',
      description: '脱壳和分级'
    },
    step4: {
      title: '储存',
      description: '装袋或装箱'
    },
    step5: {
      title: '出口',
      description: '港口装船'
    }
  },
  market: {
    title: '目的地和全球消费',
    destinations: '主要目的地',
    factors: {
      title: '市场因素',
      quotes: {
        title: '国际报价：',
        description: '纽约和伦敦交易所决定价格'
      },
      climate: {
        title: '气候条件：',
        description: '霜冻和干旱显著影响价格'
      },
      quality: {
        title: '品质：',
        description: '特种咖啡获得溢价'
      },
      logistics: {
        title: '物流：',
        description: '运输成本影响竞争力'
      }
    }
  },
  trends: {
    title: '市场趋势',
    specialty: {
      title: '特种咖啡',
      description: '对单一产地咖啡和特殊制作方法的需求增长'
    },
    certifications: {
      title: '认证',
      description: '有机、公平贸易和雨林联盟认证'
    },
    sustainability: {
      title: '可持续性',
      description: '环境负责和社会公正的做法'
    }
  }
};

// Logistics page translations
const logistics = {
  hero: {
    title: '物流与运输',
    subtitle: '出口背后的基础设施'
  },
  ships: {
    title: '货船类型',
    bulk: {
      name: '散货船',
      description: '专门运输糖等散装产品的船舶',
      capacity: '6-20万吨'
    },
    containers: {
      name: '干货集装箱',
      description: '运输袋装咖啡和包装产品',
      capacity: '1000-20000标准箱'
    },
    refrigerated: {
      name: '冷藏集装箱',
      description: '用于需要温度控制的产品',
      capacity: '200-2000标准箱'
    }
  },
  ports: {
    title: '主要出口港口',
    santos: {
      name: '桑托斯港（圣保罗）',
      description: '拉丁美洲最大港口',
      products: '糖、咖啡、大豆',
      capacity: '480万标准箱/年'
    },
    paranagua: {
      name: '巴拉那瓜港（巴拉那）',
      description: '南部主要出口走廊',
      products: '糖、大豆、玉米',
      capacity: '120万标准箱/年'
    },
    vitoria: {
      name: '维多利亚港（圣埃斯皮里图）',
      description: '矿物和咖啡重要港口',
      products: '咖啡、糖、矿物',
      capacity: '80万标准箱/年'
    },
    itaqui: {
      name: '伊塔基港（马拉尼昂）',
      description: '东北部门户',
      products: '糖、大豆、玉米',
      capacity: '60万标准箱/年'
    }
  },
  storage: {
    title: '仓储和仓库',
    silos: {
      name: '散装筒仓',
      description: '散装糖的垂直储存',
      capacity: '1-10万吨'
    },
    warehouses: {
      name: '海关仓库',
      description: '等待出口产品的仓库',
      capacity: '5000-5万吨'
    },
    refrigerated: {
      name: '冷库',
      description: '温度敏感产品的保存',
      capacity: '1000-2万吨'
    }
  },
  transport: {
    title: '国内运输',
    modes: '运输方式',
    road: {
      name: '公路',
      percentage: '70%',
      description: '国内运输的主要方式'
    },
    rail: {
      name: '铁路',
      percentage: '25%',
      description: '在某些地区使用增长'
    },
    waterway: {
      name: '水路',
      percentage: '5%',
      description: '在特定地区使用'
    },
    characteristics: {
      title: '运输特点',
      distances: {
        title: '平均距离',
        farm: '农场→仓库：50-200公里',
        warehouse: '仓库→港口：200-800公里',
        time: '平均时间：2-5天'
      },
      costs: {
        title: '物流成本',
        percent: '占最终价格的15-25%',
        fuel: '燃料：最大组成部分',
        tolls: '过路费和港口费'
      },
      seasonality: {
        title: '季节性',
        peak: '收获期高峰（5-9月）',
        demand: '运输需求更大',
        increase: '运费上涨'
      }
    }
  },
  challenges: {
    title: '挑战与机遇',
    infrastructure: {
      title: '港口基础设施',
      description: '需要现代化和扩大容量'
    },
    costs: {
      title: '物流成本',
      description: '降低运输和储存成本'
    },
    sustainability: {
      title: '可持续性',
      description: '实施环境负责的做法'
    },
    digitalization: {
      title: '数字化',
      description: '自动化和数字化过程控制'
    }
  },
  numbers: {
    title: '物流数据',
    tonnage: '年处理吨数',
    ports: '有组织港口',
    terminals: '私人码头',
    gdp: 'GDP的物流成本'
  }
};

// News page translations
const news = {
  hero: {
    title: '新闻与趋势',
    subtitle: '出口市场发生了什么？'
  },
  market: {
    title: '实时报价'
  },
  tabs: {
    recent: '最新新闻',
    analysis: '分析',
    forecasts: '预测'
  },
  analysis: {
    title: '市场分析',
    positive: {
      title: '积极因素',
      climate: '下次收获气候有利',
      demand: '国际需求增长',
      infrastructure: '物流基础设施改善'
    },
    challenges: {
      title: '挑战',
      exchange: '汇率波动',
      competition: '国际竞争',
      costs: '物流成本高'
    }
  },
  newsletter: {
    title: '保持信息更新',
    description: '直接在您的邮箱接收大宗商品市场的每周更新',
    placeholder: '您的邮箱',
    subscribe: '订阅'
  }
};

// Contact page translations
const contact = {
  hero: {
    title: '关于项目',
    subtitle: '了解我们的团队并与我们联系'
  },
  about: {
    title: '我们是谁'
  },
  objectives: {
    title: '我们的目标',
    educational: {
      title: '教育性',
      description: '教育巴西主要大宗商品的生产和出口过程'
    },
    informative: {
      title: '信息性',
      description: '提供市场、价格和行业趋势的最新数据'
    },
    connective: {
      title: '连接性',
      description: '连接对巴西农业企业感兴趣的不同受众'
    }
  },
  team: {
    title: '我们的团队'
  },
  sources: {
    title: '数据来源',
    description: '我们专门使用公认机构的官方数据，以确保所提供信息的准确性和可靠性。'
  },
  form: {
    title: '联系我们',
    subtitle: '有疑问、建议或想要贡献？与我们交谈！',
    name: '全名',
    email: '邮箱',
    subject: '主题',
    message: '消息',
    send: '发送消息',
    sending: '发送中...',
    success: '消息发送成功！我们会很快联系您。',
    error: '发送消息时出错。请重试。',
    selectSubject: '选择主题',
    subjects: {
      doubt: '数据疑问',
      suggestion: '改进建议',
      contribution: '数据贡献',
      partnership: '合作提案',
      press: '媒体',
      other: '其他'
    },
    placeholder: {
      name: '您的全名',
      email: '您的@邮箱.com',
      message: '描述您的消息（最多500字符）'
    },
    charRemaining: '剩余字符'
  },
  social: {
    title: '关注我们',
    description: '在社交媒体上关注我们，获取大宗商品市场的最新更新'
  }
};

export default {
  navigation,
  hero,
  features,
  stats,
  cta,
  sugar,
  coffee,
  logistics,
  news,
  contact
};
